module.exports = __webpack_public_path__ + "static/img/istockphoto-963427848-2048x2048.f9b09e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/istockphoto-963427848-2048x2048.png
// module id = 1752
// module chunks = 5